var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext } from "@wordpress/element";
import { filterNewComments } from "../../utils/comment";
import { UserPageAppContext } from "../providers/UserPageAppContextProvider";
const WPQT_STORED_COMMENTS_KEY = "wpqt-stored-comments";
function useLocalStorage() {
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const getStoredComments = () => __awaiter(this, void 0, void 0, function* () {
        const storedComments = localStorage.getItem(`${WPQT_STORED_COMMENTS_KEY}-${pageHash}`);
        return storedComments ? JSON.parse(storedComments) : [];
    });
    const storeComments = (comments) => __awaiter(this, void 0, void 0, function* () {
        const storedComments = yield getStoredComments();
        const newComments = filterNewComments(comments, storedComments);
        const updatedComments = [...storedComments, ...newComments];
        localStorage.setItem(`${WPQT_STORED_COMMENTS_KEY}-${pageHash}`, JSON.stringify(updatedComments));
    });
    return { getStoredComments, storeComments };
}
export { useLocalStorage };
